import { ProfitAndLossData } from "@/types/profit-and-loss-api";
import FinancialSummary from "./overview/FinancialSummary";
import LoadingPage from "../LoadingPage";

interface ProfitAndLossOverviewProps {
    data: ProfitAndLossData;
    startDate: string;
    endDate: string;
}

const ProfitAndLossOverview = (data: ProfitAndLossOverviewProps) => {
    if (!data.data) return <LoadingPage />;

    return (
        <div className="space-y-8">
            <FinancialSummary data={data.data} startDate={data.startDate} endDate={data.endDate} />
        </div>
    );
};

export default ProfitAndLossOverview;